import { defineComponent as d, computed as l, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as p, createStaticVNode as f } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "686d08f1-4309-4949-8c58-cecedb3a4c2c" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#686d08f1-4309-4949-8c58-cecedb3a4c2c)" }, u = { key: 0 }, v = /* @__PURE__ */ f('<path fill="#eee" d="m228 0 32 211-32 211h-32l-32-211L196 0Z"></path><path fill="#496e2d" d="M196 0v450H0V0Z"></path><path fill="#eee" d="m178 87-31-14-49 112L49 73 18 87l62 138-62 138 31 14 49-112 49 112 31-14-62-138Z"></path><path fill="#eee" d="M98 80 81 96 65 224l16 130 17 16 17-16 15-131-15-127-17-16Z"></path><path fill="#333" d="m154 148-10 76 10 78a159 159 0 0 0 22-77c0-28-10-54-22-77zm-112 0 9 74-9 80a159 159 0 0 1-22-77c0-28 10-54 22-77z"></path><path fill="#a2001d" d="M42 148v154a269 269 0 0 0 39 52V96c-11 12-26 30-39 52zm112 0a269 269 0 0 0-39-52v258c11-12 26-30 39-52V148Z"></path><path fill="#d80027" d="M512 0v422H228V0Z"></path><path fill="#333" d="m0 450 86-17 75 8 55-51 41 18 106-56 149 70v90H0Z"></path>', 8), g = { fill: "none" }, x = ["r"], Z = /* @__PURE__ */ d({
  __name: "kikuyu",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (c(), i("title", u, h(e.flagName), 1)) : n("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: p({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  Z as default
};
//# sourceMappingURL=kikuyu-89a287ae.js.map
